import React, { useEffect, useLayoutEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'

const MAX_STRING_LENGTH = window.innerWidth < 1200 ? 90 : 95

const RiskListItem = ({ title, desc, handleClick }) => {
  const classes = useStyles()
  const [mobileView, setMobileView] = useState(false)

  const handleResize = () => {
    if (window.innerWidth <= 600) {
      setMobileView(true)
      return
    }
    setMobileView(false)
  }

  useLayoutEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleListClick = () => {
    if (desc?.length <= MAX_STRING_LENGTH) return
    handleClick(title, desc)
  }

  const innerStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  return (
    <>
      <div className={`${classes.riskListItem} risk-item-list`}>
        <div className={`${classes.title} risk-list-title`}>{title}</div>
        {mobileView ? (
          <div className={classes.desc}> {desc} </div>
        ) : (
          <div className={'risk-list-desc'} style={innerStyles}>
            <div className={classes.desc}>
              {desc?.length > MAX_STRING_LENGTH ? (
                <>
                  {desc?.substring(0, MAX_STRING_LENGTH)}...
                  <span
                    aria-hidden='true'
                    onClick={handleListClick}
                    className='show-more'
                  >
                    ...
                    <span className={classes.readMore}>Read more</span>
                  </span>
                </>
              ) : (
                desc
              )}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default RiskListItem

const useStyles = makeStyles({
  riskListItem: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1px',
    alignItems: 'center',
    color: COLORS.GREY,
    padding: '8px 8px',
    background: COLORS.WHITE,
    borderBottom: `0.7px solid ${COLORS.GREY_11}`,
    transition: 'all .2s ease-in-out',
    '&:last-child': {
      borderBottom: `0px solid ${COLORS.GREY_11}`,
    },
    '&:hover': {
      color: COLORS.DARK_PINK,
      borderRadius: '10px',
      padding: '8px 22px',
      transform: 'translateX(0px) scale(1.1)',
      borderBottom: `0PX solid ${COLORS.GREY_11}`,
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
    },
    '@media (max-width: 600px)': {
      flexDirection: 'column',
    },
  },
  readMore: {
    textDecoration: 'underline',
  },
  icon: {
    width: '32px',
    margin: '0 14px 0 0',
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2px',
    boxSizing: 'border-box',
    '& img': {
      width: '27px',
      height: '27px',
    },
    '@media (max-width: 600px)': {
      margin: 'auto',
    },
  },
  title: {
    fontSize: '15px',
    lineHeight: '18px',
    color: 'inherit',
    flexShrink: 0,
    flexBasis: '180px',
    maxWidth: '180px',
    marginRight: '20px',
    boxSizing: 'border-box',
    fontWeight: 500,
    '@media (max-width: 600px)': {
      margin: '20px auto',
      flexBasis: 'auto',
    },
  },
  desc: {
    fontSize: '12px',
    lineHeight: '16px',
    color: 'inherit',
    maxHeight: '32px',
    position: 'relative',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      maxHeight: 'auto',
    },
  },
  pointer: {
    cursor: 'pointer',
    '& .help-text': {
      display: 'block',
    },
  },
  help: {
    fontSize: '13px',
    textDecoration: 'underline',
    cursor: 'pointer',
    display: 'none',
  },
})
